import { skipToken } from '@reduxjs/toolkit/query'
import { useState } from 'react'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { IntersectionObserverHookRefCallback } from 'react-intersection-observer-hook'
import { useFetchInfiniteFilterResourcesInfiniteQuery } from '@/api/workspace-api/directory-api'
import useCallbackRef from '@/hooks/use-callback-ref'
import { usePermissions } from '@/hooks/use-permissions'
import { FilterResource } from '@/types/schema/directory/kol-management'
import { toVoidFunction } from '@/utils/to-void-function'

/**
 * @todo refactor to useResources ref resources-selector.tsx
 */
export const useReports = (): {
  reports: FilterResource[]
  loading: boolean
  loadingRef: IntersectionObserverHookRefCallback
  hasNextPage: boolean
  getReportsByName: (reportName?: string) => void
  initialSearch: boolean
  refetch: () => void
} => {
  const { withReportPermission } = usePermissions()
  const [name, setName] = useState<string>()
  const {
    data,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isUninitialized,
    refetch,
  } = useFetchInfiniteFilterResourcesInfiniteQuery(
    withReportPermission
      ? {
          keyword: name,
          filter_resource_type: 'deep_report',
        }
      : skipToken,
  )

  const reports =
    data?.pages
      .map((page) => {
        return page.data.filter_resources
      })
      .flat() ?? []

  const [loadingRef] = useInfiniteScroll({
    loading: isFetching,
    hasNextPage,
    onLoadMore: toVoidFunction(fetchNextPage),
    rootMargin: '0px 0px 0px 0px',
  })

  const getReportsByName = useCallbackRef((reportName?: string) => {
    setName(reportName)
  })

  return {
    reports,
    loading: isFetching,
    loadingRef,
    hasNextPage,
    getReportsByName,
    initialSearch: !isUninitialized,
    refetch: toVoidFunction(refetch),
  }
}
